import * as React from 'react'
import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { t, tc } from '@owl-nest/localize'
import * as api from '@owl-nest/api-client/latest'
import * as models from '@owl-nest/models'

import * as UFE from '../UFE'

type MemberCalloutProps = {
  project: models.project.ProjectForOwner
}

export function MemberCallout({ project }: MemberCalloutProps): React.ReactElement {
  const orderEditUrl = models.project.getActiveMembershipOrder(project)?.latest_order?.edit_url
  const subscriptionName = models.project.getSubscriptionName(project, UFE.USER_LOCALE as api.Lang)
  const isSubscriptionFree = models.project.getSubscriptionType(project) === 'free'

  // TODO: LOT 2; const isSubscriptionUpdating=
  // TODO: LOT 2; const previousSubscriptionName=
  // TODO: LOT 2; const subcriptionStartDate?: string

  return (
    <MemberCalloutWrapper hasGoal={project.show_goal}>
      <plume.Callout type="info" size="medium" customIcon={plume.glyphs.fill.Success}>
        {/* TODO: LOT2 <MemberCalloutContent isSubscriptionUpdating={isSubscriptionUpdating}> */}
        <MemberCalloutContent>
          {/* TODO: LOT 2 {isSubscriptionUpdating ? (
            <plume.styles.copy.S>
              {t(
                'You are a %(subscriptionName)s member. Your subscription %(subscriptionName)s will start on %(date)s.',
                {
                  previousSubscriptionName,
                  subscriptionName,
                  date: 'test',
                },
              )}
            </plume.styles.copy.S>
          ) : ( */}
          <plume.styles.copy.S>
            {isSubscriptionFree ? (
              <>{t('You are a free member')}</>
            ) : (
              <>
                {t('You are a %(subscriptionName)s member', {
                  subscriptionName,
                })}
              </>
            )}
          </plume.styles.copy.S>
          {/* )} */}
          <plume.styles.copy.S>
            <plume.Link href={orderEditUrl}>{t('See my membership')}</plume.Link>
          </plume.styles.copy.S>
        </MemberCalloutContent>
      </plume.Callout>
    </MemberCalloutWrapper>
  )
}

const MemberCalloutWrapper = styled.div<{ hasGoal?: boolean; theme?: any }>`
  margin-bottom: 4px;
  margin-inline: 16px;
  margin-top: 13px;
  max-width: 548px;
  position: relative;
  z-index: 1;

  @media screen and (min-width: 585px) {
    width: 100%;
    margin-inline: auto;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin-top: ${({ hasGoal }) => (hasGoal ? '13px' : '32px')};
    margin-bottom: 80px;
  }

  ${plume.Callout} {
    ${plume.styles.notification.Callout} {
      ${({ theme }) => {
        return css`
          background-color: ${plume.utils.hexToRgb(theme?.colors?.primary, 0.15)};

          ${plume.glyphs.Icon} {
            color: ${theme?.colors?.primary};
          }
        `
      }}
    }

    span {
      display: block;
      width: 100%;
    }

    & > :first-child {
      border-radius: 2px;
    }
  }
`

const MemberCalloutContent = styled.div<{ isSubscriptionUpdating?: boolean }>`
  display: flex;
  flex-direction: column;

  ${plume.styles.copy.S} {
    display: inline;
  }

  ${plume.Link} {
    font-size: 14px;
  }

  @media screen and (min-width: 475px) {
    display: ${({ isSubscriptionUpdating }) => (isSubscriptionUpdating ? 'inline' : 'flex')};
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
`
